import React from 'react';
import { observer } from 'mobx-react';
import ContentStore from 'stores/Content.store';

import { Container } from 'common/components/Layout/Layout';

import styles from './Whistleblowing.module.scss';

const Whistleblowing = () => {
  const { content } = ContentStore;

  if (!ContentStore.isLoaded) {
    return null;
  }

  return (
    <div>
      <Container>
        <div
          className={styles.Content}
          dangerouslySetInnerHTML={{
            __html: content.Whistleblowing
          }}
        />
      </Container>
    </div>
  );
};

export default observer(Whistleblowing);



// WEBPACK FOOTER //
// ./src/views/Whistleblowing/Whistleblowing.js